import axiosInstance from './axiosInstance';

import type { Response } from './axiosInstance';

// GetUserList and its User / UserListResponse types were removed: nothing
// imported them, and the endpoint they called -- /admin/user/list -- has never
// existed on this backend. The admin user list lives at /admin/users and belongs
// to the aitomistic-admin SPA, not to this client.

type getUserPermissionsResponse = {
  email: string;
  permissions: { system: { [key: string]: boolean } };
  username: string;
}

export const GetUserPermissions = async (): Promise<Response<getUserPermissionsResponse> | undefined> => {
  try {
    const response = await axiosInstance.get<Response<any>>('/auth/permission', {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response?.data;
  }
  catch (e) {
    console.error('Failed to get user permissions', e);
    return undefined
  }
}

export type Announcement = {
  id: number;
  title: string;
  content: string;
  user_email: string;
  created_at: string;
  updated_at: string;
}

export type LatestAnnouncementData = {
  user_announcement: Announcement | null;
  global_announcement: Announcement | null;
}

export const GetLatestAnnouncement = async (): Promise<Response<LatestAnnouncementData> | undefined> => {
  try {
    const response = await axiosInstance.get<Response<LatestAnnouncementData>>('/announcement/latest', {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response?.data;
  } catch (e) {
    console.error('Failed to get latest announcement', e);
    return undefined;
  }
}

export const JoinRole = async (role: string): Promise<(Response<null> & { httpStatus?: number }) | undefined> => {
  try {
    const response = await axiosInstance.post<Response<null>>(`/roles/${encodeURIComponent(role)}/join`);
    return response?.data;
  } catch (e: any) {
    if (e?.response?.data) {
      return { ...(e.response.data as Response<null>), httpStatus: e.response.status };
    }
    console.error('Failed to join role', e);
    return undefined;
  }
}

export const checkRole = async (roles: string[]): Promise<(Response<{ [key: string]: boolean }> & { httpStatus?: number }) | undefined> => {
  try {
    const response = await axiosInstance.post<Response<{ [key: string]: boolean }>>(`/roles/check`, { roles });
    return response?.data;
  } catch (e: any) {
    if (e?.response?.data) {
      return undefined;
    }
    console.error('Failed to check role', e);
    return undefined;
  }
}